import {
  IIntegration,
  IntegrationStorage,
  IntegrationType,
} from '@principle-theorem/integrations';
import { IParchmentIntegrationData } from '@principle-theorem/principle-core/interfaces';
import { AtLeast, CollectionReference } from '@principle-theorem/shared';

export class ParchmentIntegrationStorage extends IntegrationStorage<IParchmentIntegrationData> {
  constructor() {
    super(IntegrationType.Parchment);
  }

  static init(
    data: AtLeast<
      IParchmentIntegrationData,
      'organisationId' | 'organisationSecret' | 'userId'
    >
  ): IParchmentIntegrationData {
    return {
      ...data,
    };
  }

  static isEnabled(
    data?: IParchmentIntegrationData
  ): data is AtLeast<
    IParchmentIntegrationData,
    'organisationId' | 'organisationSecret' | 'userId'
  > {
    return data?.organisationId && data?.organisationSecret && data?.userId
      ? true
      : false;
  }

  override async upsert(
    integrationsCollection: CollectionReference<
      IIntegration<IParchmentIntegrationData>
    >,
    data: AtLeast<
      IParchmentIntegrationData,
      'organisationId' | 'organisationSecret' | 'userId'
    >
  ): Promise<void> {
    const current = await this.get(integrationsCollection);
    return super.upsert(
      integrationsCollection,
      ParchmentIntegrationStorage.init({ ...current?.data, ...data })
    );
  }
}
